import { valueToZDBigNumber } from './bignumber';
export var RAY_DECIMALS = 27;
export var WAD = valueToZDBigNumber(10).pow(18);
export var HALF_WAD = WAD.dividedBy(2);
export var RAY = valueToZDBigNumber(10).pow(27);
export var HALF_RAY = RAY.dividedBy(2);
export var WAD_RAY_RATIO = valueToZDBigNumber(10).pow(9);
export function wadMul(a, b) {
    return HALF_WAD.plus(valueToZDBigNumber(a).multipliedBy(b)).div(WAD);
}
export function wadDiv(a, b) {
    var halfB = valueToZDBigNumber(b).div(2);
    return halfB.plus(valueToZDBigNumber(a).multipliedBy(WAD)).div(b);
}
export function rayMul(a, b) {
    return HALF_RAY.plus(valueToZDBigNumber(a).multipliedBy(b)).div(RAY);
}
export function rayDiv(a, b) {
    var halfB = valueToZDBigNumber(b).div(2);
    return halfB.plus(valueToZDBigNumber(a).multipliedBy(RAY)).div(b);
}
export function rayToWad(a) {
    var halfRatio = valueToZDBigNumber(WAD_RAY_RATIO).div(2);
    return halfRatio.plus(a).div(WAD_RAY_RATIO);
}
export function wadToRay(a) {
    return valueToZDBigNumber(a).multipliedBy(WAD_RAY_RATIO).decimalPlaces(0);
}
export function rayPow(a, p) {
    var x = valueToZDBigNumber(a);
    var n = valueToZDBigNumber(p);
    var z = !n.modulo(2).eq(0) ? x : valueToZDBigNumber(RAY);
    for (n = n.div(2); !n.eq(0); n = n.div(2)) {
        x = rayMul(x, x);
        if (!n.modulo(2).eq(0)) {
            z = rayMul(z, x);
        }
    }
    return z;
}
export function rayRoot(base, root) {
    //if (typeof base !== 'bigint' || typeof root !== 'bigint') throw new Error('Arguments must be bigints.')
    var zdBase = valueToZDBigNumber(base);
    var zdRoot = valueToZDBigNumber(root);
    var k1 = zdRoot.minus('1');
    var s = zdBase.plus('1');
    var u = valueToZDBigNumber(base);
    while (u.lt(s)) {
        s = u;
        //u = (u * k1 + base / u ** k1) / root
        // u = u
        //   .multipliedBy(k1)
        //   .plus(zdBase.dividedBy(rayPow(u, k1)))
        //   .dividedBy(zdRoot)
        u = rayDiv(rayMul(u, k1).plus(rayDiv(zdBase, rayPow(u, k1))), zdRoot);
        console.log({ u: u.toFixed() });
    }
    return s;
}
export function bnRoot(base, root) {
    //if (typeof base !== 'bigint' || typeof root !== 'bigint') throw new Error('Arguments must be bigints.')
    var zdBase = valueToZDBigNumber(base);
    var zdRoot = valueToZDBigNumber(root);
    var k1 = zdRoot.minus('1');
    var s = zdBase.plus('1');
    var u = valueToZDBigNumber(base);
    while (u.lt(s)) {
        s = u;
        //u = (u * k1 + base / u ** k1) / root
        u = u
            .multipliedBy(k1)
            .plus(zdBase.dividedBy(u.pow(k1)))
            .dividedBy(zdRoot);
    }
    return s;
}
/**
 * RayPow is slow and gas intensive therefore in v2 we switched to binomial approximation on the contract level.
 * While the results ar not exact to the last decimal, they are close enough.
 */
export function binomialApproximatedRayPow(a, p) {
    var base = valueToZDBigNumber(a);
    var exp = valueToZDBigNumber(p);
    if (exp.eq(0))
        return RAY;
    var expMinusOne = exp.minus(1);
    var expMinusTwo = exp.gt(2) ? exp.minus(2) : 0;
    var basePowerTwo = rayMul(base, base);
    var basePowerThree = rayMul(basePowerTwo, base);
    var firstTerm = exp.multipliedBy(base);
    var secondTerm = exp.multipliedBy(expMinusOne).multipliedBy(basePowerTwo).div(2);
    var thirdTerm = exp.multipliedBy(expMinusOne).multipliedBy(expMinusTwo).multipliedBy(basePowerThree).div(6);
    return RAY.plus(firstTerm).plus(secondTerm).plus(thirdTerm);
}
export function rayToDecimal(a) {
    return valueToZDBigNumber(a).dividedBy(RAY);
}
